import React from 'react';
import { TshirtsKidsS, DressesKidsS, TshirtsS, DressesWomenS, ShoesLaceUpsS, ShoesHighHeelsS, ShoesTrainersS, ScarvesShawlsS, HatsS, SportEquipmentS, SetWomenS, ShavingMenS, BabyGiftsKidsS, CookingPotS, BedSheetsS, MantelClockS, HouseS, } from '@lux/zds-icons';
import * as S from './category-icon.styles';
var CategoryIconMap = {
    55564534: DressesWomenS, // Women - Clothing
    92288919: ShoesHighHeelsS, // Women - Shoes
    164714731: ScarvesShawlsS, // Women - Accessories
    180036116: SportEquipmentS, // Women - Equipment
    144099994: SetWomenS, // Women - Beauty
    80000687: TshirtsS, // Men - Clothing
    46319661: ShoesLaceUpsS, // Men - Shoes
    178000406: ScarvesShawlsS, // Men - Accessories
    144319380: SportEquipmentS, // Men - Equipment
    230041073: ShavingMenS, // Men - Care
    206497773: DressesKidsS, // Girls
    100706627: BabyGiftsKidsS, // Girls - Toys
    262370062: DressesKidsS, // Girls - Clothing
    228689036: ShoesTrainersS, // Girls - Shoes
    138117866: HatsS, // Girls Accessories
    7215816: TshirtsKidsS, // Boys
    17310563: BabyGiftsKidsS, // Boys - Toys
    187314637: TshirtsKidsS, // Boys - Clothing
    49443013: ShoesTrainersS, // Boys - Shoes
    235007517: HatsS, // Boys - Accessories
    125050883: BedSheetsS, // Home - Textiles
    3393068: CookingPotS, // Home - Household
    211518093: MantelClockS, // Home - Accessories
    66135235: HouseS, // Home - Furniture
};
export var CategoryIcon = function (_a) {
    var withRightMargin = _a.withRightMargin, id = _a.id;
    var Icon = id && CategoryIconMap[id];
    if (!Icon) {
        return null;
    }
    return (React.createElement(S.CategoryIcon, { "data-testid": "category-icon-".concat(id), withRightMargin: withRightMargin },
        React.createElement(Icon, null)));
};
